export default "__VITE_ASSET__CLjZTFu___"